module.exports = __webpack_public_path__ + "media/video.e939243e.webm";